export default __webpack_public_path__ + "de4d2a6494c0b18b9fcc54978b7c7983.png";